import React from 'react';
import {
   Box,
   Typography,
   FormControl,
   Card,
   Dialog,
   // Select,
   MenuItem,
   Menu,
   Checkbox,
   Button,
   Tooltip,
   IconButton,
} from '@mui/material';
import styled from '@emotion/styled';
import { Container, TextInput } from './style';
import backImg from '../../../assets/back.svg';
import verticalMenu from '../../../assets/verticalMenu.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import msgIcon from '../../../assets/messageIcon3.svg';
import sendMessage from '../../../assets/sendMessage.png';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { messageSelector } from '../../../components/utils/selectors/selectors';
import {
   deleteMessage,
   getScheduledMessages,
} from '../../../components/app/features/message/messageSlice';
import { userLSAuth } from '../../../components/app/features/env';
import ScheduleIcon from '@mui/icons-material/Schedule';
import InfiniteScroll from 'react-infinite-scroll-component';

const DropDown = styled(Menu)(
   ({ theme }) => `
	position: absolute;
	right: 0;

& .MuiPopover-paper {
	border-radius:0;
}
& .MuiList-root, & .MuiMenu-list {

	border-radius:0;
}

	`
);
const Activity = styled(MenuItem)(
   ({ theme }) => `
	min-height:unset;
	padding:5px 0 ;
 box-sizing: border-box;
 white-space: nowrap;
	width: 160px;
	font-weight:600;
	border-radius:0;
	`
);

const Schedule = () => {
   const selector = useSelector(messageSelector);
   const dispatch = useDispatch();
   const [action, setAction] = React.useState('');
   const [anchorEl, setAnchorEl] = React.useState(null);
   const [isDelete, setIsDelete] = React.useState(false);
   const [checkedList, setCheckedList] = React.useState([]);
   const [itemsChecked, setItemsChecked] = React.useState(false);
   const [newData, setNewData] = React.useState([]);
   const [page, setPage] = React.useState(1);

   const setClose = () => setAnchorEl(false);
   const handleChange = (value) => {
      setAction(value);
      setAnchorEl(null);
   };
   const navigate = useNavigate();

   const actions = [
      // 'Select Message History',
      'Delete',
   ];

   // search functionality
   const [search, setSearch] = React.useState('');
   const handleSearch = (event) => {
      setSearch(event.target.value);
   };

   const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

   const handleCheckboxClick = (e) => {
      const { value, checked } = e.target;

      if (checked) {
         setCheckedList([...checkedList, parseInt(value, 10)]);
      } else {
         setCheckedList(
            checkedList.filter((item) => item != parseInt(value, 10))
         );
      }
   };

   React.useEffect(() => {
      dispatch(getScheduledMessages({ page: page }));
   }, [selector.deleted === true, page]);

   const selectItem = (e) => {
      const { checked } = e.target;
      const collection = [];

      if (checked) {
         newData.forEach((item, id) => {
            item.data.map((item, ind) => collection.push(item.id));
         });
      }

      setCheckedList(collection);
      setItemsChecked(checked);
   };

   const deleteItem = () => {
      dispatch(deleteMessage({ ids: String(checkedList) }));
      newData.map((item) => {
         item.data = item.data.filter((elem) => !checkedList.includes(elem.id));
         return item;
      });
      setAction('');
      setIsDelete(false);
      setTimeout(() => {
         window.location.reload();
      }, 3000);
   };

   React.useEffect(() => {
      const groupedData = {};
      selector?.scheduledMessages.forEach((item) => {
         const createdAt = new Date(item.scheduledAt);
         const formattedDate = new Intl.DateTimeFormat('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
         }).format(createdAt);

         if (groupedData.hasOwnProperty(formattedDate)) {
            groupedData[formattedDate].push(item);
         } else {
            groupedData[formattedDate] = [item];
         }
      });
      const newArr = [];

      for (const key in groupedData) {
         if (groupedData.hasOwnProperty(key)) {
            const value = groupedData[key];
            newArr.push({
               date: key,
               data: value,
            });
         }
      }
      newArr.sort((a, b) => new Date(b.date) - new Date(a.date));
      setNewData(newArr);
   }, [selector?.scheduledMessages]);

   const resetChecked = () => {
      setAction('');
      setCheckedList([]);
   };

   const loadmore = () => {
      if (selector.hasMore && selector.loading !== 'pending') {
         setPage(page + 1);
      }
   };

   return (
      <Container>
         <Card
            sx={{
               width: '90%',
               maxWidth: '615px',
               minHeight: '80vh',
               margin: '2rem auto',
               position: 'relative',
               boxShadow:
                  '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
               padding: '20px ',
               padding: '20px ',
               background: 'white',
               borderTopLeftRadius: '25px',
               borderTopRightRadius: '25px',
               borderBottomLeftRadius: 0,
               borderBottomRightRadius: 0,
            }}
         >
            <Box
               sx={{
                  margin: '0 auto',
                  marginTop: '1rem',
                  border: '1px solid transparent',
                  position: 'relative',
               }}
            >
               <Dialog
                  onClose={() => {
                     setIsDelete(false);
                     setAction('');
                  }}
                  open={isDelete}
               >
                  <Card sx={{ padding: '20px 30px ' }}>
                     <Typography
                        sx={{
                           fontWeight: '600',
                           fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
                           textAlign: 'center',
                           marginBottom: '2rem',
                        }}
                     >
                        Are you sure you want to delete the selected messages?
                     </Typography>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'center',
                        }}
                     >
                        <Typography
                           sx={{
                              fontWeight: '600',
                              fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
                              cursor: 'pointer',
                              marginRight: ' 1rem',
                           }}
                           onClick={() => {
                              setIsDelete(false);
                              setAction('');
                           }}
                        >
                           Cancel
                        </Typography>
                        <Typography
                           sx={{
                              fontWeight: '600',
                              fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
                              color: 'red',
                              cursor: 'pointer',
                           }}
                           onClick={() => deleteItem()}
                        >
                           Yes
                        </Typography>
                     </Box>
                  </Card>
               </Dialog>

               <img
                  src={backImg}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '40px',
                     cursor: 'pointer',
                  }}
                  onClick={() => window.history.back()}
               />

               <DropDown
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={setClose}
                  MenuListProps={{
                     'aria-labelledby': 'basic-button',
                  }}
               >
                  {actions.map((action, index) => (
                     <Activity
                        key={index}
                        onClick={(e) => handleChange(e.target.innerText)}
                     >
                        {action}
                     </Activity>
                  ))}
               </DropDown>

               <img
                  src={verticalMenu}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '25px',
                     right: 0,
                     filter:
                        'invert(27%) sepia(11%) saturate(7243%) hue-rotate(207deg) brightness(94%) contrast(88%)',
                     cursor: 'pointer',
                  }}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
               />

               <Typography
                  sx={{
                     width: 'max-content',
                     margin: '0 auto',
                     fontWeight: 600,
                     fontSize: {
                        xs: '2rem',
                        sm: '1.5rem',
                        md: '2rem',
                        lg: '2.3rem',
                     },
                     color: '#2E2C21',
                     marginTop: '0rem',
                     textAlign: 'center',
                     px: { xs: 1, sm: 0 },
                  }}
                  className="font-cormorant"
               >
                  Scheduled Messages
               </Typography>
               {
                  // action === 'Select Message History' ||
                  action === 'Delete' && (
                     <Typography
                        sx={{
                           display: 'flex',
                           alignItems: 'center',
                           fontSize: '1.1rem',

                           fontWeight: 700,
                           position: 'relative',
                           marginTop: '1rem',
                        }}
                     >
                        <Checkbox
                           checked={itemsChecked}
                           onClick={selectItem}
                           {...label}
                        />{' '}
                        select all
                        {action === 'Delete' && (
                           <Tooltip title="Delete">
                              <IconButton
                                 sx={{
                                    position: 'absolute',
                                    right:
                                       action === 'Delete' ? '80px' : '70px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                 }}
                                 onClick={() =>
                                    checkedList.length > 0 && setIsDelete(true)
                                 }
                              >
                                 <DeleteIcon />
                              </IconButton>
                           </Tooltip>
                        )}
                        <Tooltip title="Cancel">
                           <IconButton
                              sx={{
                                 position: 'absolute',
                                 right: '20px',
                                 top: '50%',
                                 transform: 'translateY(-50%)',
                                 cursor: 'pointer',
                              }}
                              onClick={() => {
                                 resetChecked();
                              }}
                           >
                              <CloseIcon />
                           </IconButton>
                        </Tooltip>
                     </Typography>
                  )
               }

               <FormControl
                  sx={{
                     width: '100%',
                     position: 'relative',
                     marginTop: action === 'Delete' ? '1rem' : '2rem',
                     marginBottom: '2rem',
                  }}
               >
                  <FaSearch
                     color="#374DA0"
                     style={{
                        zIndex: 2,
                        position: 'absolute',
                        top: '50%',
                        left: '20px',
                        transform: 'translateY(-50%)',
                        fontSize: '0.9rem',
                     }}
                  />
                  <TextInput
                     value={search}
                     fullWidth
                     placeholder="Search Scheduled Messages"
                     InputProps={{
                        style: {
                           color: '#374DA0',
                           borderRadius: '25px',
                           paddingLeft: '35px',

                           fontSize: '1rem',
                        },
                     }}
                     onChange={(event) => handleSearch(event)}
                  />
               </FormControl>
               <Button
                  sx={{
                     display: 'flex',
                     maxWidth: '280px',
                     width: '90%',
                     background: '#E5E7F2',
                     alignItems: 'center',
                     justifyContent: 'center',
                     // border: '1px solid red',
                     margin: '0.5rem auto',
                     padding: '10px 0',
                     borderRadius: '8px',
                  }}
                  onClick={() => navigate('/send-message/schedule-message')}
               >
                  <img
                     src={sendMessage}
                     style={{ marginRight: '15px' }}
                     alt="icon"
                  />
                  <Typography
                     sx={{
                        fontWeight: 600,
                        fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                     }}
                  >
                     Schedule New Message
                  </Typography>
               </Button>

               {newData.length === 0 ? (
                  <Typography
                     sx={{
                        fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                        textAlign: 'center',
                        mt: 4,
                     }}
                  >
                     {`Hey ${
                        userLSAuth()?.fullName
                           ? userLSAuth()?.fullName.split(' ')[0]
                           : ''
                     }, your Scheduled Messages will appear here!`}
                  </Typography>
               ) : (
                  <Box
                     id="scrollableDiv"
                     sx={{
                        marginTop: '2rem',
                        height: '50vh',
                        overflowY: 'auto',
                     }}
                  >
                     {newData.map((item, index) => (
                        <Box key={index}>
                           <Typography
                              sx={{
                                 color: '#374DA0',
                                 fontSize: '1rem',
                                 fontWeight: 700,
                                 marginTop: '1rem',
                              }}
                           >
                              {item.date}
                           </Typography>
                           <Box
                              sx={{
                                 background: '#EFEEF4',
                                 padding: '15px',
                                 marginTop: '1rem',
                                 borderRadius: '10px',
                                 display: 'flex',
                                 flexDirection: 'column',
                                 rowGap: '15px',
                              }}
                           >
                              {[...item?.data].reverse().map((elem, indx) => (
                                 <Box
                                    key={indx}
                                    sx={{
                                       background: '#fff',
                                       padding: '10px',
                                       borderRadius: '10px',
                                       display: 'flex',
                                       justifyContent: 'space-between',
                                    }}
                                 >
                                    <Box
                                       sx={{
                                          width: 'max-content',
                                          height: '50px',
                                          display: 'flex',
                                          alignItems: 'center',
                                       }}
                                    >
                                       {action === 'Select Message History' ||
                                       action === 'Delete' ? (
                                          <Checkbox
                                             value={elem.id}
                                             checked={checkedList.includes(
                                                elem.id
                                             )}
                                             onClick={handleCheckboxClick}
                                             {...label}
                                          />
                                       ) : (
                                          <img
                                             style={{
                                                width: '30px',
                                                marginRight: '10px',
                                             }}
                                             src={msgIcon}
                                             alt="messageIcon"
                                          />
                                       )}

                                       <Box>
                                          <Typography
                                             sx={{
                                                color: '#0F0E0E',
                                                fontSize: '0.9rem',
                                                fontWeight: 600,
                                                cursor: 'pointer',
                                                ':hover': {
                                                   textDecoration: 'underline',
                                                },
                                             }}
                                             onClick={() =>
                                                navigate(
                                                   `/send-message/history/${elem.id}`
                                                )
                                             }
                                          >
                                             {`${elem.content.slice(0, 9)}...`}
                                          </Typography>
                                          <Typography
                                             sx={{
                                                color: '#5F5E5E',
                                                fontSize: '0.8rem',
                                                fontWeight: 600,
                                                display: 'flex',
                                                alignItems: 'center',
                                                columnGap: '10px',
                                             }}
                                          >
                                             {`${
                                                new Date(
                                                   elem.scheduledAt
                                                ).getHours() % 12 || 12
                                             }:${new Date(elem.scheduledAt)
                                                .getMinutes()
                                                .toString()
                                                .padStart(2, '0')} ${
                                                new Date(
                                                   elem.scheduledAt
                                                ).getHours() >= 12
                                                   ? 'PM'
                                                   : 'AM'
                                             }`}{' '}
                                             <ScheduleIcon
                                                style={{
                                                   color: '#374da0',
                                                   fontSize: '1rem',
                                                }}
                                             />
                                          </Typography>
                                       </Box>
                                    </Box>
                                    <Box
                                       sx={{
                                          width: 'max-content',
                                          height: '50px',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'center',
                                          alignItems: 'flex-end',
                                       }}
                                    >
                                       <Typography
                                          sx={{
                                             color: '#0F0E0E',

                                             fontSize: '0.9rem',
                                             fontWeight: 600,
                                          }}
                                       >
                                          {''}
                                          {/* {search === ''
                                             ? `${elem.contactCount} contacts`
                                             : `${elem.contacts.length} contacts`} */}
                                       </Typography>
                                       <Typography
                                          sx={{
                                             color:
                                                elem.status === null ||
                                                elem.status === 'pending'
                                                   ? '#FFB017'
                                                   : elem.status === 'Some sent'
                                                   ? '#0FA958'
                                                   : '#FF1818',
                                             fontSize: '0.8rem',
                                             fontWeight: 600,
                                          }}
                                       >
                                          {elem.status === null
                                             ? 'pending'
                                             : elem.status}
                                       </Typography>
                                    </Box>
                                 </Box>
                              ))}
                           </Box>
                        </Box>
                     ))}
                     <InfiniteScroll
                        dataLength={selector.scheduledMessages.length}
                        next={loadmore}
                        hasMore={selector.hasMore}
                        loader={
                           <h4
                              style={{ textAlign: 'center', margin: '15px 0' }}
                           >
                              Loading...
                           </h4>
                        }
                        scrollableTarget="scrollableDiv"
                        endMessage={
                           <p style={{ textAlign: 'center', margin: '15px 0' }}>
                              Yay! You have seen it all
                           </p>
                        }
                     />
                  </Box>
               )}
            </Box>
         </Card>
      </Container>
   );
};

export default Schedule;
